package org.moxultimate.topwithmox.components.texts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import org.moxultimate.topwithmox.theme.DarkGrayColor
import org.moxultimate.topwithmox.theme.DarkTextColor

@Composable
fun TextNavLink(path: String,
                text: String,
                fontSize: Int = 16,
                fontWeight: FontWeight = FontWeight.Normal,
                color: Color = DarkTextColor,
                modifier: Modifier = Modifier,
                disabled: Boolean = false,
) {
    if (disabled) {
        SpanText(
            text = text,
            modifier = Modifier
                .color(DarkGrayColor)
                .fontSize(fontSize.px)
                .fontWeight(fontWeight),
        )
    } else {
        Link(
            path,
            text,
            modifier = modifier
                .color(color)
                .fontSize(fontSize.px)
                .fontWeight(fontWeight),
            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
        )
    }
}
